import React from 'react';

export const ShutterLeftPostRightFold = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 104.64 59.39"
      width="111"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h93.65v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.39V.59A.69.69 0 015.49 0h93.66a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM98.37 1.18H6.26V50.8h92.11z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h93.65v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.39V.59A.69.69 0 015.49 0h93.66a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM98.37 1.18H6.26V50.8h92.11z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h84.84v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.62c-.42 0-.77-.26-.76-.58V3.94c0-.32.34-.58.77-.58h84.84c.42 0 .77.26.77.58V48c0 .32-.35.58-.77.58H9.89zm85.5-44.09H10.67v42.92h84.72z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 51.94h103.18c.4 0 .73-.25.73-.55a.65.65 0 00-.73-.56H.73a.65.65 0 00-.73.56c-.01.3.33.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M69.88 8.37l27.78-6.03v49.49l-27.78 6.8V8.37z"
          />
          <path
            data-name="Path 2338"
            d="M98.15 52.33l-28.78 7.06V7.85l28.78-6.24zm-27.78 5.55l26.8-6.55V3.07l-26.8 5.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M72.88 13.03l22.03-4.85v3.57l-22.03 4.89v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M95.17 12l-22.56 5v-4.24l22.56-5zm-22 4.23l21.53-4.77v-2.9L73.13 13.3z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M72.88 16.64l22.03-4.89v3.57l-22.03 4.93v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M95.17 15.58l-22.56 5v-4.21l22.56-5zm-22 4.28l21.53-4.81v-2.92l-21.57 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M72.88 20.25l22.03-4.93v3.56l-22.03 4.98v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M95.17 19.15l-22.56 5.1V20l22.56-5zm-22 4.33l21.53-4.86V15.7l-21.57 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M72.88 23.89l22.03-4.98v3.57L72.88 27.5v-3.61z"
          />
          <path
            data-name="Path 2342"
            d="M95.17 22.74l-22.56 5.15v-4.27l22.56-5.09zm-22 4.37l21.53-4.9v-2.92l-21.57 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M72.88 27.5l22.03-5.02v3.56l-22.03 5.07V27.5z"
          />
          <path
            data-name="Path 2343"
            d="M95.17 26.31L72.61 31.5v-4.27l22.56-5.14zm-22 4.41l21.53-4.94v-2.92l-21.57 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M72.88 31.11l22.03-5.07v3.57l-22.03 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M95.17 29.88l-22.56 5.23v-4.27l22.56-5.18zm-22 4.45l21.53-5v-2.9l-21.57 4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M72.88 34.72l22.03-5.11v3.57l-22.03 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M95.17 33.44l-22.56 5.28v-4.26l22.56-5.23zM73.13 38l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M72.88 38.33l22.03-5.15v3.57l-22.03 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M95.17 37l-22.56 5.33v-4.26l22.56-5.27zm-22 4.55l21.53-5.08v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M72.88 41.95l22.03-5.2v3.56l-22.03 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M95.17 40.58L72.61 46v-4.32l22.56-5.32zm-22 4.59l21.53-5.12v-2.92l-21.57 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M72.88 45.58l22.03-5.24v3.57L72.88 49.2v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M95.17 44.17l-22.56 5.41v-4.26L95.17 40zm-22 4.64l21.53-5.17v-2.92l-21.57 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M72.88 49.2l22.03-5.29v3.56l-22.03 5.34V49.2z"
          />
          <path
            data-name="Path 2349"
            d="M95.17 47.74L72.61 53.2v-4.27l22.56-5.41zm-22 4.68l21.53-5.21v-2.92l-21.57 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M83.34 10.73l1.44-.32v39.52l-1.44.34V10.73z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M69.55 8.37L41.76 2.34v49.49l27.79 6.8V8.37z"
          />
          <path
            data-name="Path 2338-2"
            d="M41.26 1.61l28.78 6.24v51.54l-28.78-7.06zm27.73 7.28L42.23 3.07v48.26l26.76 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M66.53 13.03L44.5 8.18v3.57l22.03 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M44.24 7.8l22.55 5V17l-22.55-5zm22 5.5l-21.5-4.74v2.92l21.53 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M66.53 16.64L44.5 11.75v3.57l22.03 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M44.24 11.37l22.55 5v4.26l-22.55-5zm22 5.54l-21.5-4.78v2.92l21.53 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M66.53 20.25L44.5 15.32v3.56l22.03 4.98v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M44.24 14.94L66.79 20v4.27l-22.55-5.1zm22 5.58l-21.5-4.82v2.92l21.53 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M66.53 23.89L44.5 18.91v3.57l22.03 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-2"
            d="M44.24 18.53l22.55 5.09v4.27l-22.55-5.15zm22 5.63l-21.5-4.87v2.92l21.53 4.9z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M66.53 27.5L44.5 22.48v3.56l22.03 5.07V27.5z"
          />
          <path
            data-name="Path 2343-2"
            d="M44.24 22.09l22.55 5.14v4.27l-22.55-5.19zm22 5.68l-21.5-4.91v2.92l21.53 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M66.53 31.11L44.5 26.04v3.57l22.03 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M44.24 25.66l22.55 5.18v4.27l-22.55-5.23zm22 5.72l-21.5-4.95v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M66.53 34.72L44.5 29.61v3.57l22.03 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M44.24 29.23l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.5-5v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M66.53 38.33L44.5 33.18v3.57l22.03 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M44.24 32.8l22.55 5.27v4.26L44.24 37zm22 5.8l-21.53-5v2.92l21.53 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M66.53 41.95l-22.03-5.2v3.56l22.03 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M44.24 36.36l22.55 5.32V46l-22.55-5.42zm22 5.85l-21.5-5.08v2.92l21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M66.53 45.58L44.5 40.34v3.57l22.03 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M44.24 40l22.55 5.32v4.26l-22.55-5.41zm22 5.89l-21.5-5.17v2.92l21.53 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M66.53 49.2L44.5 43.91v3.56l22.03 5.34V49.2z"
          />
          <path
            data-name="Path 2349-2"
            d="M44.24 43.52l22.55 5.41v4.27l-22.55-5.46zm22 5.94l-21.5-5.17v2.92l21.53 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M56.08 10.73l-1.45-.32v39.52l1.45.34V10.73z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M34.54 8.27L6.75 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-3"
            d="M6.26 1.52l28.73 6.23v51.54l-28.77-7zm27.73 7.27L7.24 3v48.23l26.75 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M31.54 12.93L9.49 8.08v3.57l22.05 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M9.24 7.71l22.54 5V17L9.24 12zm22 5.49L9.75 8.46v2.92l21.51 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M31.54 16.54L9.49 11.65v3.57l22.05 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M9.24 11.27l22.54 5v4.27L9.24 15.48zm22 5.54L9.75 12v3l21.51 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M31.54 20.15L9.49 15.22v3.57l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M9.24 14.84l22.54 5v4.27L9.24 19.05zm22 5.58L9.75 15.6v2.92l21.51 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M31.54 23.79L9.49 18.81v3.57l22.05 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-3"
            d="M9.24 18.43l22.54 5.09v4.27L9.24 22.64zm22 5.63L9.75 19.19v2.92L31.26 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M31.54 27.4L9.49 22.38v3.57l22.05 5.06V27.4z"
          />
          <path
            data-name="Path 2343-3"
            d="M9.24 22l22.54 5.13v4.27L9.24 26.21zm22 5.67L9.75 22.76v2.92l21.51 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M31.54 31.01L9.49 25.95v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M9.24 25.56l22.54 5.18V35L9.24 29.78zm22 5.72l-21.51-5v2.92l21.51 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M31.54 34.62L9.49 29.51v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M9.24 29.13l22.54 5.23v4.26L9.24 33.34zm22 5.76l-21.51-5v2.93l21.51 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M31.54 38.23L9.49 33.08v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M9.24 32.7L31.78 38v4.27L9.24 36.91zm22 5.8l-21.51-5v2.92l21.5 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M31.54 41.85l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M9.24 36.27l22.54 5.31v4.27L9.24 40.48zm22 5.84L9.75 37v3l21.51 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M31.54 45.48L9.49 40.24v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M9.24 39.86l22.54 5.36v4.27L9.24 44.07zm22 5.89L9.75 40.62v2.92l21.51 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M31.54 49.1L9.49 43.81v3.57l22.05 5.33V49.1z"
          />
          <path
            data-name="Path 2349-3"
            d="M9.24 43.42l22.54 5.41v4.27L9.24 47.64zm22 5.94L9.75 44.19v2.92l21.51 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <path fill="#233762" d="M36.11 3.42h1.36v45.21h-1.36z" />
    </svg>
  );
};
